import { UsersMutationTypes } from './types';

export const mutations = {
    [UsersMutationTypes.SetUsers](state, {users}) {
        return state.users = users
    },
    [UsersMutationTypes.SetEmptyUsers](state) {
        state.users = { data: [], total: 0, query_total: 0 }
    },
    [UsersMutationTypes.SetChangedUser](state, {user}) {
        const foundIndex = state.users.data.findIndex(item => item._id === user._id)
        return state.users.data.splice(foundIndex, 1, user)
    },
    [UsersMutationTypes.SetDeletedUser](state, {id}) {
        const foundIndex = state.users.data.findIndex(item => item._id === id)
        return state.users.data.splice(foundIndex, 1)
    },
    [UsersMutationTypes.SetResponse](state, response) {
        return state.response = response
    },
}
